import mainFeatureSlide from "./mainFeatureSlide";

export default function () {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');

  $(`#${widgetName}`).videoWidget({
    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
    , detectIpad: IPADDETECTED
    // options
    , multiVideo: false
    , showOnMobile: true
    , maxVideos: 1
    , autoPlayVideo: true
    , loopVideo: true // Autoplay must be enabled
    , showControls: false

    , videoWidgetLoaded: function (data) {

      if (data.Slides.length > 0) {
        $('#mainFeatureSlide').remove();
        $(body).addClass('mainFeatureVideo')
      } else {
        $('#videoWidget').remove();
        $(body).addClass('noMainVideo');
        mainFeatureSlide();
      }
    }
  });
};
